import { render, staticRenderFns } from "./AddRegistration.vue?vue&type=template&id=c96932c6&"
import script from "./AddRegistration.vue?vue&type=script&lang=js&"
export * from "./AddRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports